(function () {
  var applyDestinationIdeaRecommendation = function applyDestinationIdeaRecommendation(card, recommendedProduct) {
    if (!card) {
      return;
    }
    var recommendation = card.querySelector('[data-destination-idea-recommendation]');
    if (!recommendation) {
      return;
    }
    if (!recommendedProduct || (!recommendedProduct.title && !recommendedProduct.url && !recommendedProduct.image)) {
      recommendation.setAttribute('hidden', '');
      return;
    }

    var recommendationLink = recommendation.querySelector('[data-recommendation-link]');
    var recommendationImage = recommendation.querySelector('[data-recommendation-image]');
    var recommendationTitle = recommendation.querySelector('[data-recommendation-title]');
    var recommendationPrice = recommendation.querySelector('[data-recommendation-price]');
    var isCollectionFallback = !!recommendedProduct.collection_fallback;
    var fallbackDescription = recommendedProduct.description || '';
    var priceText = recommendedProduct.price;

    if (!priceText && typeof recommendedProduct.price_cents === 'number' && window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      priceText = window.Shopify.formatMoney(recommendedProduct.price_cents);
    }

    if (recommendationLink && recommendedProduct.url) {
      recommendationLink.setAttribute('href', recommendedProduct.url);
    }
    if (recommendationTitle && recommendedProduct.title) {
      recommendationTitle.textContent = recommendedProduct.title;
    }
    if (recommendationPrice) {
      recommendationPrice.removeAttribute('data-fallback-description');
      if (isCollectionFallback && fallbackDescription) {
        recommendationPrice.textContent = fallbackDescription;
        recommendationPrice.setAttribute('data-fallback-description', 'true');
      } else if (priceText) {
        recommendationPrice.textContent = 'from ' + priceText;
      } else {
        recommendationPrice.textContent = '';
      }
    }
    if (recommendationImage) {
      var imageValue = recommendedProduct.image || recommendedProduct.image_url || recommendedProduct.image_src || recommendedProduct.featured_image;
      if (imageValue && typeof imageValue === 'object') {
        imageValue = imageValue.src || imageValue.url || imageValue.image;
      }
      if (imageValue) {
        recommendationImage.setAttribute('src', imageValue);
        recommendationImage.setAttribute('alt', recommendedProduct.title || 'Recommended product');
        recommendationImage.removeAttribute('hidden');
      } else {
        recommendationImage.setAttribute('hidden', '');
      }
    }
    recommendation.removeAttribute('hidden');
  };

  window.destinationIdeaRecommendationApply = applyDestinationIdeaRecommendation;

  if (typeof module !== 'undefined' && module.exports) {
    module.exports = {
      applyDestinationIdeaRecommendation: applyDestinationIdeaRecommendation
    };
  }
})();
